import type {
  Consultant,
  ConsultantCertification,
  ConsultantLanguageLevel,
  ConsultantSkill,
  Experience,
} from '@/types/consultant.types.ts'
import { CLEVERLINK_API_BASE_URL, RESOURCES } from '@/constants/apiConstants.ts'
import {
  resourceWithPagination,
  resourceWithSecureFetch,
  subresourceWithPagination,
} from '@/utils/apiUtils.ts'

type RouteConsultantId = Consultant['id'] | string

export const consultantsRoutes = {
  root: `${CLEVERLINK_API_BASE_URL}/${RESOURCES.CONSULTANTS}`,
  list() {
    return consultantsRoutes.root
  },
  detail(consultantId: RouteConsultantId) {
    return `${consultantsRoutes.root}/${consultantId}`
  },
  certifications(consultantId: RouteConsultantId) {
    return `${consultantsRoutes.detail(consultantId)}/${RESOURCES.CERTIFICATIONS}`
  },
  experiences(consultantId: RouteConsultantId) {
    return `${consultantsRoutes.detail(consultantId)}/${RESOURCES.EXPERIENCES}`
  },
  languageLevels(consultantId: RouteConsultantId) {
    return `${consultantsRoutes.detail(consultantId)}/${RESOURCES.LANGUAGE_LEVELS}`
  },
  skills(consultantId: RouteConsultantId) {
    return `${consultantsRoutes.detail(consultantId)}/${RESOURCES.SKILLS}`
  },
}

export const fetchConsultants = resourceWithPagination<Consultant>(
  consultantsRoutes.list,
  'consultants',
)

export const fetchConsultant = resourceWithSecureFetch<
  Consultant,
  RouteConsultantId
>(consultantsRoutes.detail, 'consultant')

export const fetchConsultantCertifications = subresourceWithPagination<
  ConsultantCertification,
  RouteConsultantId
>(consultantsRoutes.certifications, "consultant's certifications")

export const fetchConsultantExperiences = subresourceWithPagination<
  Experience,
  RouteConsultantId
>(consultantsRoutes.experiences, "consultant's experiences")

export const fetchConsultantLanguageLevels = subresourceWithPagination<
  ConsultantLanguageLevel,
  RouteConsultantId
>(consultantsRoutes.languageLevels, "consultant's languages' level")

export const fetchConsultantSkills = subresourceWithPagination<
  ConsultantSkill,
  RouteConsultantId
>(consultantsRoutes.skills, "consultant's skills")
